module.exports = __webpack_public_path__ + "img/mo_button6.71958cea.png";